import React, { FC } from 'react'
import classNames from 'classnames'
import equal from 'fast-deep-equal'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { CheckoutShoppingBagType, CheckoutChannel, CheckoutChannelMap } from 'types/checkout'
import { Spacer } from 'components/Utility'
import { OrderCardBodySummaryLabel } from 'components/Card'
import { LightTag } from 'components/Tag'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getShoppingBags } from 'reducks/store/selectors'
import { FlexRow } from 'components/Flex'

type Props = {
  amount: number
  checkoutChannel?: CheckoutChannel
  discountAmount: number
  orderLabel: string
  orderType: string
  request: string
  shoppingBags: CheckoutShoppingBagType[]
}

const OrderCardBodySummary: FC<Props> = React.memo(
  (props) => {
    const { amount, checkoutChannel, discountAmount, orderLabel, orderType, request, shoppingBags } = props
    const storeShoppingBags = useSelector((state: State) => getShoppingBags(state))
    return (
      <div className={styles.order__body__summary}>
        <FlexRow justifyContent={'start'}>
          <img src={orderType === 'daily' ? '/icon/blue/order.svg' : '/icon/green/order.svg'} alt={'注文時刻'} />
          <Spacer size={4} />
          <span className={classNames(text.font_small)}>{orderLabel}</span>
        </FlexRow>
        <Spacer size={8} />
        <OrderCardBodySummaryLabel label={'注文タイプ'}>
          {orderType === 'daily' && <LightTag color={'blue'} label={'当日'} />}
          {orderType === 'preorder' && <LightTag color={'green'} label={'事前予約'} />}
        </OrderCardBodySummaryLabel>
        <Spacer size={8} />
        {(storeShoppingBags.length > 0 || shoppingBags?.length > 0) && (
          <>
            <OrderCardBodySummaryLabel label={'レジ袋'}>
              <p className={text.font_small}>
                {(() => {
                  const selectedBags = shoppingBags?.filter((bag) => bag.quantity > 0) ?? []
                  return selectedBags.length === 0
                    ? '無し'
                    : selectedBags.map((bag) => `${bag.name}(${bag.quantity}枚)`)
                })()}
              </p>
            </OrderCardBodySummaryLabel>
            <Spacer size={8} />
          </>
        )}
        <OrderCardBodySummaryLabel label={'購入経路'}>
          <p className={text.font_small}>{checkoutChannel ? CheckoutChannelMap[checkoutChannel] : 'アプリ'}</p>
        </OrderCardBodySummaryLabel>
        <Spacer size={8} />
        <OrderCardBodySummaryLabel label={'売上(税込)'}>
          <p className={text.font_small}>{amount.toLocaleString()}円</p>
        </OrderCardBodySummaryLabel>
        {discountAmount !== 0 && (
          <OrderCardBodySummaryLabel label={'クーポン'}>
            <p className={text.font_small}>-{discountAmount.toLocaleString()}円</p>
          </OrderCardBodySummaryLabel>
        )}
        {request && request !== '' && (
          <>
            <Spacer size={8} />
            <p className={`${text.font_small} ${text.color_grey_01}`}>{'お客さまからのご要望：'}</p>
            <Spacer size={4} />
            <p className={text.font_small}>{HTMLReactParser(returnCodeToBr(request))}</p>
          </>
        )}
      </div>
    )
  },
  (prev, next) => equal(prev, next)
)

export default OrderCardBodySummary
